/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Address_InvalidInputs */

const en_error_address_invalid = /** @type {(inputs: Error_Address_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The address cannot be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The address cannot be saved as it is:" |
*
* @param {Error_Address_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_address_invalid = /** @type {((inputs?: Error_Address_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Address_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_address_invalid(inputs)
});